import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Avatar,
} from "@mui/material";
import GroupsIcon from "@mui/icons-material/Groups";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import EastIcon from '@mui/icons-material/East';


const cardData = [
  {
    icon: <GroupsIcon sx={{ fontSize: 40 }} />,
    title: "Expert Instructors",
    desc: "Learn from certified yoga masters and meditation coaches with years of experience.",
  },
  {
    icon: <SmartphoneIcon sx={{ fontSize: 40 }} />,
    title: "Access Anytime, Anywhere",
    desc: "Practice at your convenience with live and on-demand sessions across all devices.",
  },
  {
    icon: <ChatBubbleOutlineIcon sx={{ fontSize: 40 }} />,
    title: "24/7 Student Support",
    desc: "Need any help? Our instructors and support team are available round the clock to assist you.",
  },
  {
    icon: <SelfImprovementIcon sx={{ fontSize: 40 }} />,
    title: "Personalized Programs",
    desc: "Get customized plans that align with your goals, lifestyle, and fitness journey.",
  },
];

const WhyChooseUs = () => {
  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 8, md: 12 },
        px: { xs: 2, md: 8 },
        color: "#fff",
        overflow: "hidden",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {/* Background Image with Gradient Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `
            linear-gradient(to bottom right, rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
            url(/images/whychooseus.jpeg)
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          zIndex: 0,
        }}
      />

      {/* Overlay Blur */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backdropFilter: "blur(4px)",
          WebkitBackdropFilter: "blur(4px)",
          zIndex: 1,
        }}
      />

      {/* Content Section */}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        {/* Header Section */}
        <Box sx={{ textAlign: "left", maxWidth: "700px", mb: 6 }}>
          <Typography
            variant="subtitle1"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              fontSize: "1rem",
              fontWeight: 500,
              color: "#d1d1d1",
            }}
          >
            ➜ Why Choose Us?
          </Typography>
          <Typography
            variant="h4"
            sx={{
              mt: 1,
              mb: 2,
              fontSize: { xs: "1.8rem", md: "2.5rem" },
            }}
          >
            Elevate Your Mind, Body, and Soul
          </Typography>
          <Typography variant="body1" sx={{ color: "#dcdcdc", lineHeight: 1.7 }}>
            We offer a holistic approach to wellness, blending traditional
            wisdom with modern techniques to help you live a balanced life.
          </Typography>

            {/* Explore Button */}
        <Box sx={{ textAlign: "end", mt: 6 }}>
          

            <Button
      variant="contained"
      sx={{
        backgroundColor: "#fff",
        color: "#000",
        borderRadius: "50px",
        px:1,
        textTransform: "none",
        fontWeight: 500,
        fontSize: { xs: "0.9rem", md: "1rem" },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1.5,
        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
        "&:hover": { backgroundColor: "#f5f5f5" },
      }}
    >
      <Typography sx={{paddingLeft:1}}> Explore Services</Typography>
      <Box
        sx={{
          backgroundColor: "#000",
          borderRadius: "50%",
          width: { xs: 30, md: 34 },
          height: { xs: 30, md: 34 },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EastIcon sx={{ color: "#fff", fontSize: "1.1rem" }} />
      </Box>
    </Button>
        </Box>
        </Box>
        

        {/* Cards Grid */}
        <Grid container spacing={3} justifyContent="start" mt={10} >
          {cardData.map((card, index) => (
            <Grid item xs={12} sm={6} md={2} key={index}>
              <Card
                sx={{
                  height: "100%",
                  width:320,
                  borderRadius: "20px",
                  background: "rgba(255,255,255,0.15)",
                  boxShadow: "0px 10px 25px rgba(0,0,0,0.1)",
                  backdropFilter: "blur(12px)",
                  WebkitBackdropFilter: "blur(12px)",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "#fff",
                  textAlign: "left",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0px 20px 35px rgba(0,0,0,0.3)",
                    background: "rgba(255,255,255,0.25)",
                  },
                }}
              >
                <CardContent sx={{ p: 4,display:"flex",justifyContent:"start",flexDirection:"column",alignItems:"start", }}>
                  <Avatar
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      width: 70,
                      height: 70,
                      mx:0,
                      my:2,
                      textAlign:"start",
                     
                    }}
                  >
                    {card.icon}
                  </Avatar>
                  <Typography
                    variant="h6"
                    sx={{
                      
                      mb: 1,
                      color: "#fff",
                      fontSize: "1.1rem",
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "0.9rem",
                      lineHeight: 1.6,
                    }}
                  >
                    {card.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

      
      </Box>
    </Box>
  );
};

export default WhyChooseUs;
